import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";

import type {
  BankAccountDetailResponseDto,
  BankAccountResponseDto,
  BankMasterResponseDto,
  CreateBankAccountRequestDto,
  CreateBankAccountResponseDto,
  UpdateBankAccountRequestDto
} from "../dtos/bank-account-dto";

export const BankAccountService = {
  getBankMaster: async () =>
    httpClient
      .get(ENDPOINTS.BANK_INFORMATION.MASTER)
      .json<BankMasterResponseDto>(),

  getList: async () =>
    httpClient
      .get(ENDPOINTS.BANK_INFORMATION.LIST)
      .json<BankAccountResponseDto>(),

  reveal: async () =>
    httpClient
      .get(ENDPOINTS.BANK_INFORMATION.REVEAL)
      .json<BankAccountResponseDto>(),

  revealDetail: async ({ bankInfoId }: { bankInfoId: string }) =>
    httpClient
      .get(ENDPOINTS.BANK_INFORMATION.REVEAL_DETAIL(bankInfoId))
      .json<BankAccountDetailResponseDto>(),

  getDetail: async ({ bankInfoId }: { bankInfoId: string }) =>
    httpClient
      .get(ENDPOINTS.BANK_INFORMATION.DETAIL(bankInfoId))
      .json<BankAccountDetailResponseDto>(),

  create: async ({ payload }: { payload: CreateBankAccountRequestDto }) =>
    httpClient
      .post(ENDPOINTS.BANK_INFORMATION.CREATE, { json: payload })
      .json<CreateBankAccountResponseDto>(),

  update: async ({
    bankInfoId,
    payload
  }: {
    bankInfoId: string;
    payload: UpdateBankAccountRequestDto;
  }) =>
    httpClient
      .put(ENDPOINTS.BANK_INFORMATION.UPDATE(bankInfoId), { json: payload })
      .json<CreateBankAccountResponseDto>(),

  delete: async ({ bankInfoId }: { bankInfoId: string }) =>
    httpClient
      .delete(ENDPOINTS.BANK_INFORMATION.DELETE(bankInfoId))
      .json<{ success: boolean }>()
};
